module.exports = __webpack_public_path__ + "static/header-mobile-30724b88926a7e043e608b35c6a5af1b.svg";